module.exports = __webpack_public_path__ + "static/media/orange.c7864499.png";